const eventName = "booking-validate-rooms";
const event = new CustomEvent(eventName, { bubbles: true });

const validateRoomsEvent = { eventName, event }

export default validateRoomsEvent;